import { useTranslation } from 'react-i18next'

import { formatResendTimerSeconds } from '../../../../../hooks'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer } from '../../../../Form'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import Text from '../../../../Text'
import { LOGIN_FORM_FIELD_HEIGHT } from '../../Login.constants'
import { LOGIN_FORM_PHONE_VERIFICATION_FIELD_NAME_CODE } from '../LoginFormPhoneVerification'

import * as styles from './LoginFormPhoneVerificationFields.module.css'

function LoginFormPhoneVerificationFields({
  isLoading,
  resendTimerSecondsLeft,
}) {
  const { t } = useTranslation()

  return (
    <FormFieldsContainer>
      <div className={styles.codeInputContainer}>
        <FormikField
          Component={InputField}
          Field={FieldStackedLabel}
          disabled={isLoading}
          height={LOGIN_FORM_FIELD_HEIGHT}
          label={t('Auth.SignInByPhoneVerificationCodeLabelKey')}
          name={LOGIN_FORM_PHONE_VERIFICATION_FIELD_NAME_CODE}
          placeholder={t('Auth.SignInByPhoneVerificationCodePlaceholderKey')}
        />
        <Text isSecondary>
          {resendTimerSecondsLeft > 0
            ? t('Auth.SignInByPhoneVerificationCodeResendTimerTextKey', {
                resendTimerSecondsLeft: formatResendTimerSeconds(
                  resendTimerSecondsLeft
                ),
              })
            : t('Auth.SignInByPhoneVerificationCodeDidNotRecievedCodeTextKey')}
        </Text>
      </div>
    </FormFieldsContainer>
  )
}

export default LoginFormPhoneVerificationFields
